import { Collection } from 'modules/core/lib/mobx-rest'

import IdentifierType from 'modules/employees/store/models/IdentifierType'

class IdentifierTypes extends Collection<IdentifierType> {
  get cacheKey(): string {
    return 'identifierTypes'
  }

  model() {
    return IdentifierType
  }
}

export { IdentifierTypes }
